/** System access roles — must match backend employees.role / JWT. */
export const SYSTEM_ROLES = [
  { value: "employee", label: "Employee", description: "Self-service: attendance, leave, payslips" },
  { value: "manager", label: "Manager", description: "Team approvals and limited team views" },
  { value: "hr", label: "HR", description: "People, payroll, attendance, and lifecycle" },
  { value: "admin", label: "Super Admin", description: "Organisation owner with full access" },
];

export const DEFAULT_EMPLOYEE_ROLE = "employee";

/** Roles that appear in reporting-manager dropdowns by default. */
export const MANAGER_ELIGIBLE_ROLES = ["admin", "hr", "manager"];

/**
 * Recommended 3-layer reporting structure (extensions allowed, e.g. Manager → HR).
 * Layer 0: Admin / higher leadership
 * Layer 1: Manager / HR
 * Layer 2: Employee
 */
export const HIERARCHY_LAYER_GUIDE = [
  { layer: 0, label: "Super Admin", roles: ["admin"], hint: "Organisation owner — usually no manager" },
  { layer: 1, label: "Manager / HR", roles: ["manager", "hr"], hint: "Reports to leadership; may report to each other" },
  { layer: 2, label: "Employee", roles: ["employee"], hint: "Reports to a Manager or HR" },
];

const LOOKUP = Object.fromEntries(SYSTEM_ROLES.map((r) => [r.value, r]));

export function normalizeEmployeeRole(value) {
  if (!value || !String(value).trim()) return DEFAULT_EMPLOYEE_ROLE;
  const key = String(value).trim().toLowerCase();
  return LOOKUP[key]?.value || DEFAULT_EMPLOYEE_ROLE;
}

export function formatRoleLabel(role) {
  const key = normalizeEmployeeRole(role);
  return LOOKUP[key]?.label || key.charAt(0).toUpperCase() + key.slice(1);
}

export function isEmployeeOnlyRole(role) {
  return normalizeEmployeeRole(role) === "employee";
}

/** Suitable for reporting-manager pickers (admin / hr / manager). */
export function isManagerEligibleRole(role) {
  return MANAGER_ELIGIBLE_ROLES.includes(normalizeEmployeeRole(role));
}

export function hierarchyLayerLabel(depth) {
  if (depth <= 0) return "Super Admin";
  if (depth === 1) return "HR / Manager";
  return "Employee";
}
